const COLOR_SCHEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export default class SidebarNav {
  constructor() {
    this.container = document.querySelector('#mega-menu-wrap-primary');
    this.colorScheme = this.getPreferredColorScheme();
    document.body.dataset.theme = this.colorScheme;
  }

  init() {
    if (this.container) {
      this.container.insertAdjacentHTML('beforeend', '<hr>');
      this.addColorSchemeToggle();
      this.addCollapseButton();
      this.enableTooltips();
      this.enableMobileTrigger();
    }
  }
  getPreferredColorScheme() {
    const storedColorScheme = localStorage.getItem('colorScheme');
    if (storedColorScheme) return storedColorScheme;

    const currentColorScheme = document.body.dataset.theme;
    if (currentColorScheme) return currentColorScheme;

    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? COLOR_SCHEMES.DARK : COLOR_SCHEMES.LIGHT;
  }

  addColorSchemeToggle() {
    const html = `
            <div class="menu-interactive-item color-scheme-toggle">
                <span class="color-scheme--light"><i class="fa-solid fa-sun"></i> Light</span>
                <span class="color-scheme--dark"><i class="fa-solid fa-moon"></i> Dark</span>
                <i class="fa-solid fa-toggle-on"></i>
            </div>
        `;
    this.container.insertAdjacentHTML('beforeend', html);
    requestAnimationFrame(() => this.registerColorSchemeToggleClickHandler());
  }

  registerColorSchemeToggleClickHandler() {
    this.container
      .querySelector('.color-scheme-toggle')
      .addEventListener('click', () => {
        const nextColorScheme =
          this.colorScheme === COLOR_SCHEMES.LIGHT
            ? COLOR_SCHEMES.DARK
            : COLOR_SCHEMES.LIGHT;

        document.body.dataset.theme = nextColorScheme;
        localStorage.setItem('colorScheme', nextColorScheme);
        this.colorScheme = nextColorScheme;
        this.closeMenu();
      });
  }

  addCollapseButton() {
    const html = `
            <div class="menu-interactive-item menu-toggle">
                <span class="dashicons dashicons-exit"></span> <span class="menu-toggle-text">Collapse</span>
            </div>
        `;
    this.container.insertAdjacentHTML('beforeend', html);
    requestAnimationFrame(() => this.registerCollapseButtonClickHandler());
  }

  registerCollapseButtonClickHandler() {
    this.container
      .querySelector('.menu-toggle')
      .addEventListener('click', () => {
        document.body.classList.toggle('sidebar-nav-collapsed');
      });
  }

  enableTooltips() {
    for (const link of this.container.querySelectorAll('.mega-menu-link')) {
      const linkText = link.textContent.trim();
      link.setAttribute('data-title', linkText);
      link.innerHTML = `<span class="link-text">${linkText}</span>`;
    }
  }

  openMenu() {
    document.body.classList.add('sidebar-nav-expanded');
    setTimeout(() => {
      document
        .querySelector('#mega-menu-wrap-primary .mega-menu-toggle')
        .classList.add('mega-menu-open');
      document.body.classList.add('mega-menu-primary-mobile-open');
    }, 200);
  }

  closeMenu() {
    document.body.classList.remove('sidebar-nav-expanded');
    setTimeout(() => {
      document
        .querySelector('#mega-menu-wrap-primary .mega-menu-toggle')
        .classList.remove('mega-menu-open');
      document.body.classList.remove('mega-menu-primary-mobile-open');
    }, 200);
  }

  enableMobileTrigger() {
    const openTrigger = document.querySelector('.site-header .dashicons-menu');
    const closeTrigger = document.querySelector(
      '#mega-menu-wrap-primary .mega-toggle-animated'
    );

    if (openTrigger && closeTrigger) {
      openTrigger.addEventListener('click', () => this.openMenu());
      closeTrigger.addEventListener('click', () => this.closeMenu());
      window.addEventListener(
        'click',
        (e) =>
          e.target !== openTrigger &&
          !this.container.parentElement.contains(e.target) &&
          this.closeMenu()
      );
    }
  }
}
